import type { Immutable } from "immer";
import React from "react";

import type { FeaturedReviewBlock as FeaturedReviewBlockValue } from "@reactivated";

import { FlagshipReviewsLink } from "../../apps/retail-locator/FlagshipReviewsLink";

/**
 * Faithful port of the legacy server-rendered
 * ``cms/blocks/flagship/featured_review.html`` (FlagshipPage
 * ``FeaturedReviewBlock``).
 *
 * ``featured_quote`` / ``featured_quote_author`` are plain ``CharBlock`` text
 * (NOT richtext), so they are rendered as escaped React text. The legacy markup
 * wrapped the quote in literal HTML entities (``&#x201C;`` ... ``&#x201D;`` and
 * ``&mdash;``); reproduced here with the equivalent unicode chars
 * (``“`` / ``”`` / ``—``).
 *
 * When ``show_reviews_link`` is set, the interactive "See More Testimonials"
 * scroll-to-reviews button renders as a REAL React child (NOT baked into a
 * string), so its click handler hydrates and stays live. It is wrapped in a
 * bare ``<div>`` to reproduce the boundary the legacy nested island emitted
 * around it (StoreFront DOM-parity precedent).
 */
export const FlagshipFeaturedReviewBlock = (
    props: Immutable<{ value: FeaturedReviewBlockValue }>,
): React.JSX.Element => {
    const v = props.value;
    return (
        <section className="pullquote">
            <div className="pullquote__quote">
                <p className="pullquote__copy">
                    {"“"}
                    {v.featured_quote}
                    {"”"}{" "}
                    <span className="pullquote__copy--deemphasize">
                        {"—"} {v.featured_quote_author}
                    </span>
                </p>
            </div>
            {v.show_reviews_link ? (
                <div>
                    <FlagshipReviewsLink />
                </div>
            ) : null}
        </section>
    );
};
